import React from "react";
import ReactDOM from "react-dom/client";
//Apply a style normalizer across browsers.
import "@@/css/normalize.css";

//This placing is important, we want the styles to apply after our normalize
//but before our custom theme as we want any theme tweaks to have higher priority.
import "@@/config/PrimeReact";


import '@@/css/global.css';


//Apply our custom theme overrides
import "@@/css/selkirk-theme.css";

import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

//See file for details of availale options for store configurations.
import '@@/config/Stores';
import '@@/config/Layout';
import '@@/config/ExtendNumeral';
import indexConfig from "@@/pages/index";

let cache = {};
const keyReg = /\.\/(.+)\.js$/;

console.info(
    `%cApplication is running in %c${process.env.NODE_ENV} %cmode. \n`,
    "color:gray",
    "font-weight:bold",
    "color:gray"
);


function importAll( r ) {
    r.keys().forEach( ( key ) => {
        const result = keyReg.exec( key );
        let strKey = result[1];
        cache[strKey] = r( key );
    } );
}

if ( window.baseURL && !window.location.href.match( window.baseURL ) ) {


    window.location = `${window.baseURL}/`;


}
else {

    //Load all files in pages directory
    importAll( require.context( "./pages/", true, /\.js$/ ) );

    const routes = Object.keys( cache ).filter( ( key ) => key !== "index" ).map( ( key ) => {


        const path = `/${key}/*`;

        return {
            path: path,
            element: React.createElement( cache[key].default )
        }

    } );

    const router = createBrowserRouter(
        [
            ...routes,
            indexConfig
        ],
        {
            basename: window.baseURL
        }
    );

    const root = ReactDOM.createRoot( document.getElementById( "root" ) );

    root.render(
        <>
        {/*<LandingApp/>*/}
        <RouterProvider router={router} />
        </>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();


}
